module.exports = __webpack_public_path__ + "img/2.f3ca2ecc.jpg";